module.exports = __webpack_public_path__ + "static/media/star-large.6a63a7da.svg";